import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class DOPurchaseControls extends HTMLElement {
  #abortController = null;
  #generation = 0;

  connectedCallback() {
    this.#abortController?.abort();
    this.#abortController = new AbortController();
    document.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#abortController.signal,
      capture: true,
    });
  }

  disconnectedCallback() {
    ++this.#generation;
    this.#abortController?.abort();
  }

  #scope(element) {
    return element.closest('quick-add-dialog, product-card') || element.closest('.shopify-section');
  }

  #status(show) {
    const status = this.parentElement?.querySelector('.do-selection-error');
    if (status) status.hidden = !show;
  }

  #failSelection() {
    this.inert = true;
    this.removeAttribute('aria-busy');
    this.#status(true);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element)) return;
    if (this.#scope(event.target) !== this.#scope(this)) return;
    if (!event.promise) return;

    const generation = ++this.#generation;
    this.inert = true;
    this.setAttribute('aria-busy', 'true');
    this.#status(false);

    event.promise
      .then(({ detail }) => {
        if (generation !== this.#generation || !this.isConnected) return;
        const html = detail?.html;
        if (!html) {
          this.#failSelection();
          return;
        }

        const nextController = Array.from(html.querySelectorAll('do-purchase-controls')).find(
          (element) => element.dataset.sectionId === this.dataset.sectionId &&
            element.dataset.blockId === this.dataset.blockId
        );

        if (!nextController) {
          this.#failSelection();
          return;
        }

        const nextVariantInput = nextController.querySelector('input[name="id"]');
        const resolvedVariantId = nextVariantInput?.value;
        morph(this, nextController, { childrenOnly: true });
        const variantInputs = this.querySelectorAll('input[name="id"]');
        if (variantInputs.length && !resolvedVariantId) {
          this.#failSelection();
          return;
        }
        for (const input of variantInputs) {
          input.value = resolvedVariantId;
          input.setAttribute('value', resolvedVariantId);
        }
        this.dataset.productId = nextController.dataset.productId;
        this.dataset.doControlState = nextController.dataset.doControlState;
        this.inert = false;
        this.removeAttribute('aria-busy');
        this.#status(false);
      })
      .catch(() => {
        if (generation === this.#generation && this.isConnected) this.#failSelection();
      });
  };
}

if (!customElements.get('do-purchase-controls')) {
  customElements.define('do-purchase-controls', DOPurchaseControls);
}
